import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["overlay", "overlayImg"]

  open(event) {
    const src = event.currentTarget.dataset.src
    this.overlayImgTarget.src = src
    this.overlayTarget.classList.remove("hidden")
    document.body.style.overflow = "hidden"
  }

  close() {
    this.overlayTarget.classList.add("hidden")
    this.overlayImgTarget.src = ""
    document.body.style.overflow = ""
  }

  closeOnBackdrop(event) {
    if (event.target === this.overlayTarget) this.close()
  }
}
